var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCheekTattooLeft = function SvgCheekTattooLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 30,
    height: 34,
    viewBox: "0 0 0.84 0.96",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".str0{stroke:#000;stroke-width:.14;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:22.9256}.fil0{fill:none}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_2370544129968"
  }, /*#__PURE__*/React.createElement("path", {
    className: "fil0 str0",
    d: "M.37.09C.66 0 .85.25.75.54.7.68.63.81.53.88.43.94.13.69.13.5.13.29.18.14.37.09z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0 str0",
    d: "M.38.52C.32.57.21.56.14.57H.07"
  })))));
};

export default SvgCheekTattooLeft;